import { httpService } from "./http-service";

export const newHttpService = {
  get(endpoint: string, data = {}) {
    return ajax(endpoint, "GET", data);
  },
  post(endpoint: string, data = {}) {
    return ajax(endpoint, "POST", data);
  },
  put(endpoint: string, data = {}) {
    return ajax(endpoint, "PUT", data);
  },
  delete(endpoint: string, data = {}) {
    return ajax(endpoint, "DELETE", data);
  },
  graphql(companyName: string, query: string | { query: string, variables: { [key: string]: any } }) {
    const reqBody = typeof query === 'string'
      ? { company_name: companyName, query }
      : { company_name: companyName, ...query };
    return this.post("/api/backoffice/graphql", reqBody);
  },
};

async function ajax(
  endpoint: string,
  method = "GET",
  data: { [key: string]: any }
) {
  try {
    const url = new URL(endpoint, process.env.REACT_APP_ENTER_BACKEND_URL).href;
    const access_token = httpService.getAccessToken();
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (method === "GET") {
      const urlSearchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(data))
        urlSearchParams.set(key, value);
      const rawResponse = await fetch(`${url}?${urlSearchParams}`, { headers });
      if (!rawResponse.ok) throw rawResponse;
      return rawResponse.json();
    }

    const rawResponse = await fetch(url, {
      method,
      headers,
      body: JSON.stringify(data),
    });
    if (!rawResponse.ok) throw rawResponse;
    if (rawResponse.headers.get("Content-Type") === "text/plain")
      return rawResponse.text();
    return rawResponse.json();
  } catch (err) {
    console.log(
      `Had Issues ${method}ing to the new backend, endpoint: ${endpoint}, with data: ${JSON.stringify(
        data
      )}`
    );
    console.dir(err);
    throw err;
  }
}
